import styled from 'styled-components';
import {
	Button,
	Input
} from 'reactstrap';

import { color } from '~/assets/styles/colors';

export const ButtonStyled = styled(Button)`
	background-color: ${({ disabled }) =>
		!disabled ? '#dbdbdb' : color.primary} !important;
	border-radius: 0 !important;
	border: 0 !important;
	color: ${({ disabled }) =>
		!disabled ? color.gray : color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.primary} !important;
		opacity: 0.6 !important;
	}
`;

export const CheckBoxCss = styled(Input)`
	width: 20px;
	height: 20px;

	background-color: white !important;

`;

export const TextClick = styled.div`
	cursor: pointer;

	margin-right: 20px;
	font-size: 18px;

	svg {
		color: ${color.secondary};
	}
`;
